var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 13,
    viewBox: "0 0 9 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.689 0.232028L8.64282 5.77766C8.75485 5.86705 8.84478 5.97794 8.90643 6.10271C8.96808 6.22748 9 6.36319 9 6.50052C9 6.63786 8.96808 6.77356 8.90643 6.89834C8.84478 7.02311 8.75485 7.13399 8.64282 7.22338L1.689 12.769C1.02525 13.2983 0 12.8595 0 12.0462V0.953302C0 0.139984 1.02525 -0.29881 1.689 0.232028Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightIcon);
export default __webpack_public_path__ + "static/media/rightIcon.c8df6985e2d2b7f6122e718f0ccb7fcc.svg";
export { ForwardRef as ReactComponent };